import { gql } from "@apollo/client";

export const GET_INTERNET_REGISTRATIONS_CONFIG = gql`
	query getInternetRegistrationsConfig {
		msgbox_Configuration {
			ConfigurationId
			IsReapitInternetRegistrationsEnabled
		}
	}
`;

export const GET_LATEST_MESSAGE = gql`
	query GetLatestMessage($conversationId: Int) {
		msgbox_Message(
			order_by: { DateTime: desc }
			where: { ConversationId: { _eq: $conversationId } }
			limit: 1
		) {
			DateTime
			MessageId
		}
	}
`;
